// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2Sxfo","modalFooterButton":"ModalNotes_modalFooterButton__2bAGu"};